<app-header></app-header>
<app-sidebar></app-sidebar>

<!-- <app-sidebar></app-sidebar> -->
<app-right-sidebar></app-right-sidebar>
<app-sidemenu-modal></app-sidemenu-modal>
<div class="app-container" [dir]="direction">
  <router-outlet></router-outlet>
</div>
